// @ts-ignore
import React, { useState, useEffect } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom'
import Home from './components/home/Home.tsx'
import Inventory from './components/inventory/Inventory.tsx'
import SideBar from './components/sideBar/SideBar.tsx'
import Scanning from './components/scanning/Scanning.tsx'
import User from './components/user/User.tsx'
import ActivityReport from './components/activityReport/ActivityReport.tsx'
import Login from './components/login/Login.tsx'
import Edit from './components/Edit/Edit.tsx'
import NotFound from './components/NotFound/NotFound.tsx'
import AddBp from './components/addBp/AddBp.tsx'
import 'antd/dist/antd.min.css'
import { UserContext } from './userContext.tsx'
import { service } from './api/middleware/middleware.ts'
import { notification } from 'antd'
import AddUser from './components/addUser/AddUser.tsx'
import SplashScreen from './components/splashScreen/SplashScreen'
import Reference from './components/Reference/Reference'
import SSOLogin from './components/SSOLogin'
// import ASNHome from './components/ASN/Home/Home.tsx'
// import Scan from './components/ASN/Scan/Scan.tsx'


const Wrapper = (props) => {
  const [loading, setLoading] = useState(true)
  const [open, setOpen] = useState(false)
  const [offline, setOffline] = useState(false)
  const [user, setUser] = useState(undefined)
  const { component: Component } = props

  useEffect(() => {
    window.addEventListener('offline', (e) => {
      notification.error({
        duration: null,
        message: 'Connexion',
        description: 'Un probleme de connexion est survenue'
      })
    })
    window.addEventListener('online', (e) => { setOffline(false) })
    let isMounted = true
    async function checkUser() {
      const data = localStorage.getItem('user')
      if (isMounted) {
        setUser(JSON.parse(data))
        setLoading(false)
      } else {
        setLoading(false)
      }
    }
    checkUser()
    return () => { isMounted = false }
  }, [])

  return (
    <div style={{ height: '90%' }}>
      {user
        ?
        <UserContext.Provider value={{ user, setUser }}>
          <SideBar setOpen={setOpen} open={open} />
          <User setOpen={setOpen} open={open} />
          <Component />
        </UserContext.Provider>
        : loading
          ? <SplashScreen />
          : <Navigate to="/login" replace />
      }
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Navigate to="/404_not_found" replace />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/loginOk/:accessToken/:refreshToken/:email" element={<SSOLogin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Wrapper component={Home} />} />
        <Route path='/inventory' element={<Wrapper component={Inventory} />} />
        <Route path='/scanning/:bpId/:sku' element={<Wrapper component={Scanning} />} />
        <Route path="/scanning/:bpId/:sku/:trayNumber" element={<Wrapper component={Scanning} />} />
        <Route path="activity_report" element={<Wrapper component={ActivityReport} />} />
        <Route path='/edit/:bpId/:sku' element={<Wrapper component={Edit} />} />
        <Route path='/edit/:bpId/:sku/:status' element={<Wrapper component={Edit} />} />
        <Route path="/add_bp" element={<Wrapper component={AddBp} />} />
        <Route path='/add_user' element={<Wrapper component={AddUser} />} />
        <Route path='/reference' element={<Wrapper component={Reference} />} />
        {/* <Route path='/asn' element={<Wrapper component={ASNHome} />} /> */}
        {/* <Route path="/asn/scanning/:asnId" element={<Wrapper component={Scan} />} /> */}
        <Route path="/404_not_found" element={<NotFound />} />
        <Route path='/healthz' element={<Navigate to='/login' replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
